export enum Role {
  MEMBER = 'member',
  CONTRIBUTOR = 'contributor',
  COACH = 'coach',
  TEAM_LEAD = 'team_lead',
  ADMIN = 'admin',
}

const exclusiveRoles: ReadonlySet<Role> = new Set([Role.MEMBER, Role.CONTRIBUTOR])

export function groupOrganizationRoles(
  roles: readonly Role[],
): { roles: Role[]; isExclusive: boolean }[] {
  const exclusiveGroup = roles.filter((role) => exclusiveRoles.has(role))
  const remainingGroup = [
    ...roles.filter((role) => !exclusiveRoles.has(role) && role !== Role.ADMIN),
  ]

  return [
    { roles: exclusiveGroup, isExclusive: true },
    { roles: remainingGroup, isExclusive: false },
    { roles: roles.filter((role) => role === Role.ADMIN), isExclusive: false },
  ]
    .filter((group) => group.roles.length > 0)
    .map((group) => ({
      roles: group.roles,
      isExclusive: group.isExclusive,
    }))
}

export function toggleOrganizationRole(roles: readonly Role[], role: Role): Role[] {
  if (roles.includes(role)) {
    return roles.filter((selectedRole) => selectedRole !== role)
  }

  const withoutExclusivePartner = exclusiveRoles.has(role)
    ? roles.filter((selectedRole) => !exclusiveRoles.has(selectedRole))
    : [...roles]

  return [...withoutExclusivePartner, role]
}

export function iconForRole(role: Role): string {
  switch (role) {
    case Role.CONTRIBUTOR:
      return 'person_eye'
    case Role.COACH:
      return 'supervisor_account'
    case Role.ADMIN:
      return 'admin_panel_settings_outline'
    case Role.TEAM_LEAD:
      return 'supervisor_account'
    default:
      return 'person_outline'
  }
}
